import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Franchise from './pages/Franchise';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import './style.css';
import FloatingButtons from './components/FloatingButtons';
import ScrollToTopButton from './components/ScrollToTopButton';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/franchise" element={<Franchise />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <FloatingButtons />
      <ScrollToTopButton />
    </Router>
  );
}

export default App;
